export const EXIT_INTENT_MAX_SHOWINGS = 2;
export const EXIT_INTENT_COOLDOWN_MS = 60 * 1000;
export const EXIT_INTENT_PHONE_NUMBER = '+1 (855) 525 5338';
export const EXIT_INTENT_PHONE_NUMBER_TEL = '+18555255338';
export const EXIT_INTENT_EXCLUDED_PATHS: readonly string[] = ['/education', '/privacy-policy'];
